import { upperCase } from "lodash";
import { translate } from "src/services";
import { Image, TextDisplay, TopLogo } from "src/styled";
import { BannerContent, BottomLogo, RightDisplay } from "../styled";

interface Props {
  backgroundImage?: string;
  backgroundColor?: string;
  bottomLogo?: string;
  topLogo?: string;
  children?: React.ReactNode;
}

const RightDisplayPanel = ({
  backgroundImage,
  backgroundColor,
  bottomLogo,
  topLogo,
  children,
}: Props) => {
  return (
    <RightDisplay
      backgroundColor={backgroundColor}
      backgroundSrc={backgroundImage}
    >
      {topLogo && (
        <TopLogo>
          <TextDisplay
            margin="large no xSmall"
            size="small"
            align="center"
            block
            color={`${backgroundImage ? "grayDarker" : "gray"}`}
          >
            {upperCase(translate("common.poweredBy"))}
          </TextDisplay>
          <Image src={topLogo} />
        </TopLogo>
      )}
      {children && (
        <BannerContent biggerTopMargin={!!topLogo}>{children}</BannerContent>
      )}
      {bottomLogo && (
        <BottomLogo>
          <TextDisplay
            margin="large no xSmall"
            size="small"
            align="center"
            block
            color="grayDarker"
          >
            {upperCase(translate("common.poweredBy"))}
          </TextDisplay>
          <Image src={bottomLogo} />
        </BottomLogo>
      )}
    </RightDisplay>
  );
};

export default RightDisplayPanel;
